import React from "react";
import BackComponent from "../../backComponent/BackComponent";
import Colors from "../../../assets/colors/Colors";
import WorldMap from "./WorldMap";
import styled from "styled-components";
import TierComponent from "./TierComponent";
import {ReportDataProps} from "../../../interfaces/RankingsAndLevelsInterfaces";
import {SkeletonWorldCircle} from "../../SkeletonLoader/SkeletonLoaders";
import withLoadingAnimation from "../../AnimationWrapper/AnimationWrapper";
import Constants from "../../../data/Constants";
import {useTranslation} from "react-i18next";

const MapContainerDiv = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${(props: {isLife: boolean}) => (props.isLife ? Colors.backgroundGray: Colors.backgroundWhite)};
    height: 100%;
    color: white;
    width: 100%;
    minWidth: 1400px;
`;

const RowDivF1 = styled.div`
    display: flex;
    flex-direction: row;
    flex: 0 1 auto;
`;

const TitleDiv = styled.div`
    flex: 8;
    font-size: 80px;
    font-family: DMSans-Medium;
    padding-left: 150px;
    color: ${(props: {isLife: boolean}) => (props.isLife ? Colors.fontWhite: Colors.fontGray)};
`;

interface MapComponentProps {
    reportData: ReportDataProps | undefined,
    isLife: boolean,
    allDataLoaded: boolean
}

const MapComponent: React.FC<MapComponentProps> = ({reportData, isLife, allDataLoaded}) => {
    const { t } = useTranslation();
    return (
        <MapContainerDiv isLife={isLife}>
            <RowDivF1>
                <BackComponent
                    backRoute={Constants.routes.rankings}
                    label={ t('back') }
                    customStyle={{justifyContent: 'center', alignItems: 'center', marginTop: 25, marginRight: 25, marginLeft: 25, display: 'flex'}}
                    backColor={isLife ? Colors.fontWhite : Colors.fontGray}
                />
            </RowDivF1>
            <RowDivF1>
              <TitleDiv isLife={isLife}>{t('mapContainer.title')}</TitleDiv>
              <TierComponent isLife={isLife}/>
            </RowDivF1>
            <div style={{flex: '9 1 auto', position: 'relative', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                {
                    withLoadingAnimation(
                        <WorldMap reportData={reportData} isLife={isLife}/>,
                        <SkeletonWorldCircle customStyle={{display: "flex", justifyContent: "center", alignItems: "center", height: '70%'}}/>,
                        allDataLoaded
                    )
                }
            </div>

        </MapContainerDiv>
    );
};

export default MapComponent;
